const generateComparatorGroupValues = (referenceMap) => {
    if (referenceMap?.populationReference && referenceMap.comparatorDescriptionReference) {
        return {
            "combinationMethod": "all-of",
            "characteristic": [
                {
                    "description": "inclusion in " + referenceMap.populationReference.display,
                    "code": { "text": "Member of" },
                    "valueReference": referenceMap.populationReference,
                    "exclude": false
                },
                {
                    "description": "exposed to " + referenceMap.comparatorDescriptionReference.display,
                    "code": { "text": "Exposed to" },
                    "valueReference": referenceMap.comparatorDescriptionReference,
                    "exclude": false
                }
            ]
        }
    }
};

export default generateComparatorGroupValues;